import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/beach.jpg'
import HeaderSocials from './HeaderSocials' 

const header = () => {
  return (
    <header>
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Niko Boykin</h1>
        <h5 className='text-light'>Fullstack Developer</h5>
        <CTA />
        <HeaderSocials />


        <div className="portfolioPic">
          <img src={ME} alt='me' />
        </div>

        <a href='#contact' className='scroll__down'>Click To Scroll Down</a>
      </div>
    </header>
  )
}

export default header